module.exports = __webpack_public_path__ + "img/trash.3bee4350.svg";